{{if data && data.length  > 0}}
<table class="u-table-list">
	<tr>
		<th>获奖时间</th><th>礼品名称</th>	</tr>
	{{each data v idx}}
		<tr>
			<td>{{v._getTime}} </td><td>{{v.prizeDesc}}</td>			
			
		</tr>
	{{/each}}

</table>　
{{else}}
	还没有您的获奖记录
{{/if}}




// WEBPACK FOOTER //
// /usr/local/src/vipp-cli/web_modules/component/hdplatform/giftEx/newgiftExchangeList.tpl